export const EVENTS = {
  FETCH_CUSTOMER_TOKEN: "CUSTOMER_TOKEN",
  FETCH_CUSTOMER_TOKEN_SUCCESS: "CUSTOMER_TOKEN_SUCCESS",
  FETCH_CUSTOMER_TOKEN_ERROR: "CUSTOMER_TOKEN_ERROR",

  FETCH_CONTACT_US: "FETCH_CONTACT_US",
  FETCH_CONTACT_US_SUCCESS: "FETCH_CONTACT_US_SUCCESS",
  FETCH_CONTACT_US_ERROR: "FETCH_CONTACT_US_ERROR",

  FETCH_MY_PROFILE: "FETCH_MY_PROFILE",
  FETCH_MY_PROFILE_SUCCESS: "FETCH_MY_PROFILE_SUCCESS",
  FETCH_MY_PROFILE_ERROR: "FETCH_MY_PROFILE_ERROR",

  FETCH_MY_MORTGAGE: "FETCH_MY_MORTGAGE",
  FETCH_MY_MORTGAGE_SUCCESS: "FETCH_MY_MORTGAGE_SUCCESS",
  FETCH_MY_MORTGAGE_ERROR: "FETCH_MY_MORTGAGE_ERROR",

  FETCH_HOME_PAGE: "FETCH_HOME_PAGE",
  FETCH_HOME_PAGE_SUCCESS: "FETCH_HOME_PAGE_SUCCESS",
  FETCH_HOME_PAGE_ERROR: "FETCH_HOME_PAGE_ERROR",

  FETCH_SAVE_YOUR_PREFERENCES: "FETCH_SAVE_YOUR_PREFERENCES",
  FETCH_SAVE_YOUR_PREFERENCES_SUCCESS: "FETCH_SAVE_YOUR_PREFERENCES_SUCCESS",
  FETCH_SAVE_YOUR_PREFERENCES_ERROR: "FETCH_SAVE_YOUR_PREFERENCES_ERROR",

  FETCH_YOUR_PREFERENCES: "FETCH_YOUR_PREFERENCES",
  FETCH_YOUR_PREFERENCES_SUCCESS: "FETCH_YOUR_PREFERENCES_SUCCESS",
  FETCH_YOUR_PREFERENCES_ERROR: "FETCH_YOUR_PREFERENCES_ERROR",

  FETCH_YOUR_TODO_LISTS: "FETCH_YOUR_TODO_LISTS",
  FETCH_YOUR_TODO_LISTS_SUCCESS: "FETCH_YOUR_TODO_LISTS_SUCCESS",
  FETCH_YOUR_TODO_LISTS_ERROR: "FETCH_YOUR_TODO_LISTS_ERROR",

  FETCH_YOUR_TODO_LISTS_PREFERENCES: "FETCH_YOUR_TODO_LISTS_PREFERENCES",
  FETCH_YOUR_TODO_LISTS_PREFERENCES_SUCCESS:
    "FETCH_YOUR_TODO_LISTS_PREFERENCES_SUCCESS",
  FETCH_YOUR_TODO_LISTS_PREFERENCES_ERROR:
    "FETCH_YOUR_TODO_LISTS_PREFERENCES_ERROR",

  FETCH_MY_DOCUMENTS: "FETCH_MY_DOCUMENTS",
  FETCH_MY_DOCUMENTS_SUCCESS: "FETCH_MY_DOCUMENTS_SUCCESS",
  FETCH_MY_DOCUMENTS_ERROR: "FETCH_MY_DOCUMENTS_ERROR",

  FETCH_MY_DOCUMENTS_DOWNLOAD: "FETCH_MY_DOCUMENTS_DOWNLOAD",
  FETCH_MY_DOCUMENTS_DOWNLOAD_SUCCESS: "FETCH_MY_DOCUMENTS_DOWNLOAD_SUCCESS",
  FETCH_MY_DOCUMENTS_DOWNLOAD_ERROR: "FETCH_MY_DOCUMENTS_DOWNLOAD_ERROR",

  FETCH_MY_DOCUMENTS_VIEW: "FETCH_MY_DOCUMENTS_VIEW",
  FETCH_MY_DOCUMENTS_VIEW_SUCCESS: "FETCH_MY_DOCUMENTS_VIEW_SUCCESS",
  FETCH_MY_DOCUMENTS_VIEW_ERROR: "FETCH_MY_DOCUMENTS_VIEW_ERROR",

  FETCH_VALIDATE_USER: "FETCH_VALIDATE_USER",
  FETCH_VALIDATE_USER_SUCCESS: "FETCH_VALIDATE_USER_SUCCESS",
  FETCH_VALIDATE_USER_ERROR: "FETCH_VALIDATE_USER_ERROR",

  FETCH_API_ERROR: "FETCH_API_ERROR",
};
